(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8291"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8291"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lkSG9", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("iZjXV")).then(()=>parcelRequire('iGo1W'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dtgFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a761427c0e7cbf40$export$2e2bcd8739ae039);
function $a761427c0e7cbf40$export$2e2bcd8739ae039(selector) {
    const container = document.querySelector(selector);
    if (container != null) {
        const datalayerSelectors = container.querySelectorAll("*[data-datalayer-event]");
        if (datalayerSelectors.length > 0) datalayerSelectors.forEach((datalayerSelector)=>{
            const datalayerData = datalayerSelector.dataset;
            if (datalayerData.datalayerEvent === 'click') datalayerSelector.addEventListener('click', (e)=>{
                const params = {};
                for(const data in datalayerSelector.dataset)if (data.startsWith('datalayerParam')) {
                    let paramName = data.replace('datalayerParam', '');
                    paramName = paramName[0].toLowerCase() + paramName.slice(1);
                    params[paramName] = datalayerSelector.dataset[data];
                }
                dataLayer.push(params);
            });
        });
    }
}

});

parcelRegister("5tLFX", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("dNLwc"))($parcel$resolve("3V7Yf")),
    (parcelRequire("dNLwc"))($parcel$resolve("bR4Pn"))
]).then(()=>parcelRequire('ahvTJ'));

});

parcelRegister("iLLRq", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("3V7Yf")).then(()=>parcelRequire('lnYl4'));

});

parcelRegister("g7Xn1", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("k4dBs")),
    (parcelRequire("dNLwc"))($parcel$resolve("lvKQV"))
]).then(()=>parcelRequire('erAGX'));

});
parcelRegister("8TD9g", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("2QrQH", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("bvluu")).then(()=>parcelRequire('dYPlz'));

});

parcelRegister("jB2uX", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("30ojN")).then(()=>parcelRequire('2RdiN'));

});

parcelRegister("70kBm", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("6qyhY")).then(()=>parcelRequire('hHvo9'));

});

parcelRegister("kzXD6", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("8KpWZ")),
    (parcelRequire("dNLwc"))($parcel$resolve("ks5b7"))
]).then(()=>parcelRequire('hUXuW'));

});

parcelRegister("9ttiI", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("kiwxz")),
    (parcelRequire("dNLwc"))($parcel$resolve("3PGxA"))
]).then(()=>parcelRequire('6Q7HS'));

});

parcelRegister("kIatT", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lDf2j")).then(()=>parcelRequire('5zlCi'));

});

parcelRegister("5Ym2Q", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("74n9F")).then(()=>parcelRequire('64XE4'));

});

parcelRegister("7vcEJ", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("7Ift6")).then(()=>parcelRequire('hKkVi'));

});

parcelRegister("1yqaf", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lRsNX")).then(()=>parcelRequire('HtOBZ'));

});

parcelRegister("bir69", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("8TD9g"))($parcel$resolve("9bEGi")),
    (parcelRequire("dNLwc"))($parcel$resolve("6VM44"))
]).then(()=>parcelRequire('bIktz'));

});

var $22466312ef961161$exports = {};
$parcel$extendImportMap({
    "iZjXV": "semanticStatement.e02ee174.js",
    "bR4Pn": "joinFlow.7774eb36.js",
    "3V7Yf": "priceChange.3132053c.js",
    "lvKQV": "revisedComparisonTable.a41f2125.js",
    "k4dBs": "revisedComparisonTable.fe4fd8e5.css",
    "bvluu": "benefitsCarouselToggle.2bc998c0.js",
    "30ojN": "reviewCalculator.0099a4c1.js",
    "6qyhY": "productListings.a02e69a0.js",
    "ks5b7": "locationSearchMap.50460d1c.js",
    "8KpWZ": "locationSearchMap.228c39c0.css",
    "3PGxA": "saveQuoteForm.84bb7ede.js",
    "kiwxz": "saveQuoteForm.3914235e.css",
    "lDf2j": "tabs.d38c0193.js",
    "74n9F": "modals.50d812cc.js",
    "7Ift6": "inPageLinks.2c4b541d.js",
    "lRsNX": "loadingSpinners.cc4e251e.js",
    "6VM44": "webChat.97192f3e.js",
    "9bEGi": "webChat.6b4101c5.css"
});

const $3412aa856898edce$var$mobileNav = document.getElementById('mobile-menu');
if ($3412aa856898edce$var$mobileNav !== null) {
    const mobileNavBtn = document.getElementById('menu-btn');
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    const headerLogo = document.getElementById('header-logo');
    const corpLogo = document.getElementById('corporate-logo');
    const searchForm = document.getElementById('search-form');
    const search = document.getElementById('search');
    const setMenuOpen = (isOpen = true)=>{
        mobileNavBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        $3412aa856898edce$var$mobileNav.hidden = !isOpen;
        headerLogo.hidden = !$3412aa856898edce$var$mobileNav.hidden && mobileMediaQuery.matches;
        if (corpLogo) corpLogo.hidden = !$3412aa856898edce$var$mobileNav.hidden && mobileMediaQuery.matches;
        searchForm.hidden = $3412aa856898edce$var$mobileNav.hidden && mobileMediaQuery.matches;
        search.placeholder = mobileMediaQuery.matches ? 'Search Westfund' : 'Search';
    };
    mobileNavBtn.addEventListener('click', ()=>{
        setMenuOpen($3412aa856898edce$var$mobileNav.hidden);
        document.body.classList.toggle('overflow-hidden');
    });
    setMenuOpen(!mobileMediaQuery.matches);
    try {
        mobileMediaQuery.addEventListener('change', (e)=>setMenuOpen(!e.matches));
    } catch (e) {
        // Safari doesn't understand mobileMediaQuery.addEventListener
        mobileMediaQuery.addListener((e)=>setMenuOpen(!e.matches));
    }
}


function $efc299feefd996f2$var$initHistoryBackButton() {
    const buttons = document.querySelectorAll('.js-history-back');
    if (buttons) buttons.forEach((elem)=>{
        elem.addEventListener("click", function() {
            history.back();
        });
    });
}
$efc299feefd996f2$var$initHistoryBackButton();


const $c1805f1e5c255f90$var$joinForms = document.querySelectorAll("form[data-join-step]");
function $c1805f1e5c255f90$var$trackDomestic(joinForm, step) {
    // Step 1.1 - Membership Status
    if (step == "membership-status") $c1805f1e5c255f90$var$trackStepMembershipStatus(joinForm, "quoteStep1.1", "Step 1.1");
    // Step 2 - Cover Selection
    if (step == "what-cover") $c1805f1e5c255f90$var$trackStepWhatCover(joinForm);
    // Step 3 - Details
    if (step == "details") $c1805f1e5c255f90$var$trackStepDetails(joinForm, "quoteStep3", "Step 3");
    // Step 4 - Lead Capture
    if (step == "lead-capture") $c1805f1e5c255f90$var$trackStepLeadCapture(joinForm);
// For Hospital Selection, See HTML implementation in the Hospital Step View.
// For Extras Selection, See HTML implementation in the Hospital Step View.
}
function $c1805f1e5c255f90$var$trackOverseas(joinForm, step) {
    // Step 1.1 - Overseas Purpose
    if (step == "overseas-purpose") $c1805f1e5c255f90$var$trackStepOverseasPurpose(joinForm);
    // Step 2 - Membership Status
    if (step == "membership-status") $c1805f1e5c255f90$var$trackStepMembershipStatus(joinForm, "quoteStep2", "Step 2");
    // Step 3 - Details
    if (step == "details") $c1805f1e5c255f90$var$trackStepDetails(joinForm, "quoteStep3", "Step 3");
    // Step 4 - Lead Capture
    if (step == "lead-capture") $c1805f1e5c255f90$var$trackStepLeadCapture(joinForm);
// For Hospital Selection, See HTML implementation in the Hospital Step View.
// For Extras Selection, See HTML implementation in the Hospital Step View.
}
function $c1805f1e5c255f90$var$calculateAge(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);
    return String(Math.abs(age_dt.getUTCFullYear() - 1970));
}
function $c1805f1e5c255f90$var$trackStepResidency(joinForm) {
    joinForm.addEventListener("submit", ()=>{
        const selectedResidencyElem = document.querySelector('input[name="Residency"]:checked');
        dataLayer.push({
            event: "quoteStep1",
            step_number: 'Step 1',
            residencyStatus: selectedResidencyElem.dataset.analyticsValue
        });
    });
}
function $c1805f1e5c255f90$var$trackStepOverseasPurpose(joinForm) {
    joinForm.addEventListener("submit", ()=>{
        dataLayer.push({
            event: "quoteStep1.1",
            step_number: "Step 1.1",
            visitorType: window.Westfund.AnalyticsData.visitorType
        });
    });
}
function $c1805f1e5c255f90$var$trackStepMembershipStatus(joinForm, eventName, stepNumber) {
    joinForm.addEventListener("submit", ()=>{
        const formData = new FormData(joinForm);
        const memberStatus = formData.get("MemberStatus") || "new";
        dataLayer.push({
            event: eventName,
            step_number: stepNumber,
            visitorType: window.Westfund.AnalyticsData.visitorType,
            memberType: memberStatus == "new" ? 'non-member' : 'member'
        });
    });
}
function $c1805f1e5c255f90$var$trackStepDetails(joinForm, eventName = "quoteStep3", stepNumber = "Step 3") {
    joinForm.addEventListener("submit", ()=>{
        const formData = new FormData(joinForm);
        const mainAge = formData.get("MainAgeRangeLabel");
        const coverType = formData.get("CoverType");
        const state = formData.get("State");
        const visaSubclass = formData.get("VisaType");
        let partnerAge = '';
        if ($c1805f1e5c255f90$var$hasPartner(coverType)) partnerAge = formData.get("PartnerAgeRangeLabel");
        const detailsData = {
            event: eventName,
            coverType: coverType,
            state: state,
            mainAge: mainAge,
            govtRebateTier: formData.get("GovtRebateTier"),
            pregnancyOnly: formData.get("PregnancyOnly") === "true" ? "true" : "false",
            visitorType: window.Westfund.AnalyticsData.visitorType,
            coverSelection: window.Westfund.AnalyticsData.cover,
            originCountry: 'Australia',
            memberType: window.Westfund.AnalyticsData.memberType
        };
        if (partnerAge !== '') detailsData.partnerAge = partnerAge;
        // We no longer have access to origin country for overseas visitors
        if (window.Westfund.IsOverseas) {
            detailsData.originCountry = '';
            detailsData.visaSubclass = visaSubclass;
        }
        if (stepNumber && stepNumber !== '') detailsData.step_number = stepNumber;
        dataLayer.push(detailsData);
    });
}
function $c1805f1e5c255f90$var$trackStepWhatCover(joinForm) {
    joinForm.addEventListener("submit", ()=>{
        const formData = new FormData(joinForm);
        const cover = formData.get("Cover") || "";
        dataLayer.push({
            event: "quoteStep2",
            step_number: "Step 2",
            coverSelection: cover === 'hospital-extras' ? "Hospital & Extras" : "Ambulance Cover",
            visitorType: window.Westfund.AnalyticsData.visitorType,
            memberType: window.Westfund.AnalyticsData.memberType
        });
    });
}
function $c1805f1e5c255f90$var$trackStepLeadCapture(joinForm) {
    joinForm.addEventListener("submit", ()=>{
        const formData = new FormData(joinForm);
        const analytics = window.Westfund.AnalyticsData || {};
        const leadCapture = {
            event: "quoteStep4",
            step_number: 'Step 4',
            coverType: analytics.coverType || '',
            state: analytics.state || '',
            mainAge: analytics.mainAge || '',
            govtRebateTier: analytics.govtRebateTier || '',
            pregnancyOnly: analytics.pregnancyOnly || 'false',
            visitorType: analytics.visitorType || '',
            coverSelection: analytics.cover || '',
            originCountry: analytics.originCountry || 'Australia',
            memberType: window.Westfund.AnalyticsData.memberType
        };
        if ($c1805f1e5c255f90$var$hasPartner(analytics.coverType)) leadCapture.partnerAge = analytics.partnerAge || '';
        if (window.Westfund.IsOverseas) leadCapture.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
        dataLayer.push(leadCapture);
    });
}
function $c1805f1e5c255f90$var$isFamily(coverType) {
    if (coverType === "family") return true;
    else if (coverType === "extendedfamily") return true;
    else if (coverType === "disabilityfamily") return true;
    return false;
}
// Cover types that include a second adult, and so have a partnerAge to report.
function $c1805f1e5c255f90$var$hasPartner(coverType) {
    return $c1805f1e5c255f90$var$isFamily(coverType) || coverType === "couple";
}
$c1805f1e5c255f90$var$joinForms.forEach((joinForm)=>{
    const getSelectOptionText = (name)=>{
        const formData = new FormData(joinForm);
        const selectValue = formData.get(name);
        const selectElement = joinForm.querySelector(`[name="${name}"]`);
        if (selectElement) {
            const selectedOption = selectElement.querySelector(`option[value="${selectValue}"]`);
            const isHidden = selectElement.closest('.hidden');
            return isHidden ? '' : (selectedOption?.innerHTML || '').trim();
        }
        return '';
    };
    if (joinForm !== null) {
        const step = joinForm.getAttribute("data-join-step");
        if (step == "edit" || step == "semantic-statement") $c1805f1e5c255f90$var$trackStepDetails(joinForm, "coverDetailsUpdated", "");
        // Step 1 - Residency
        if (step === "residency") $c1805f1e5c255f90$var$trackStepResidency(joinForm);
        if (window.Westfund.IsOverseas) $c1805f1e5c255f90$var$trackOverseas(joinForm, step);
        else $c1805f1e5c255f90$var$trackDomestic(joinForm, step);
        // Below are the non refactored steps for tracking, this mainly includes the join process, the next time
        // we update the join process, we will refactor this section.
        switch(step){
            case "tell-us-about-you":
                joinForm.addEventListener("submit", ()=>{
                    let locationType = '';
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') locationType = document.querySelector('[name="VisaInAustralia"]:checked').value === 'Y' ? 'onshore' : 'offshore';
                    const aboutYouData = {
                        'event': 'aboutYouStep1',
                        'flow_section': 'About You',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'referral_channel': getSelectOptionText('HeardAbout'),
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'hospitalCoverLevel': window.Westfund.AnalyticsData.hospitalCoverLevel,
                        'extrasCoverLevel': window.Westfund.AnalyticsData.extrasCoverLevel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'locationType': locationType
                    };
                    aboutYouData.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) aboutYouData.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') aboutYouData.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(aboutYouData);
                });
                break;
            case "tell-us-about-you-contact":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const coverType = formData.get("Cover") || "";
                    const state = formData.get("MainHomeState") || formData.get("MainHomeStateOnly") || "";
                    const data = {
                        'event': 'aboutYouStep2',
                        'flow_section': 'About You',
                        'step_number': 'Step 2',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': state,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "tell-us-about-you-dependents":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'aboutYouStep3',
                        'flow_section': 'About You',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "your-cover-rebate":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'yourCoverStep1',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "why_choose":
            case "your-cover-transfer":
                if (window.Westfund.IsOverseas) joinForm.addEventListener("submit", ()=>{
                    const currentFund = getSelectOptionText('PreviousFundId');
                    const data = {
                        'event': 'aboutYouStep4',
                        'flow_section': 'About You',
                        'step_number': 'Step 4',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': currentFund || '',
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                else joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'yourCoverStep2',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 2',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': getSelectOptionText('PreviousFundId'),
                        'whyWestfund': getSelectOptionText('JoinReasonId'),
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'hospitalCoverLevel': window.Westfund.AnalyticsData.hospitalCoverLevel,
                        'extrasCoverLevel': window.Westfund.AnalyticsData.extrasCoverLevel,
                        'coverSelection': window.Westfund.AnalyticsData.cover
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "your-cover-lhc":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'yourCoverStep3',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "your-cover-concession":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'yourCoverStep4',
                        'flow_section': 'Your Cover',
                        'step_number': 'Step 4',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "pay-promo":
                joinForm.addEventListener("submit", ()=>{
                    const formData = new FormData(joinForm);
                    const promoCode = formData.get("PromotionCodeId") || "";
                    const data = {
                        'event': 'paySubmitStep1',
                        'promoCode': promoCode,
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 1',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "pay-start":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'paySubmitStep2',
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 2',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "pay-terms":
                joinForm.addEventListener("submit", ()=>{
                    const data = {
                        'event': 'paySubmitStep3',
                        'flow_section': 'Pay & Submit',
                        'step_number': 'Step 3',
                        'visitorType': window.Westfund.AnalyticsData.visitorType,
                        'currentFund': window.Westfund.AnalyticsData.currentFund,
                        'whyWestfund': window.Westfund.AnalyticsData.whyWestfund,
                        'referral_channel': window.Westfund.AnalyticsData.referralChannel,
                        'coverSelection': window.Westfund.AnalyticsData.cover,
                        'coverType': window.Westfund.AnalyticsData.coverType,
                        'state': window.Westfund.AnalyticsData.state,
                        'locationType': window.Westfund.AnalyticsData.locationType
                    };
                    data.mainAge = window.Westfund.AnalyticsData.mainAge;
                    if ($c1805f1e5c255f90$var$hasPartner(window.Westfund.AnalyticsData.coverType)) data.partnerAge = window.Westfund.AnalyticsData.partnerAge;
                    if (window.Westfund.AnalyticsData.visitorType === 'Overseas') data.visaSubclass = window.Westfund.AnalyticsData.visaSubclass;
                    dataLayer.push(data);
                });
                break;
            case "pay-details":
                break;
            default:
                const memberIdMatches = window.location.href.match(/MemberId=([^&]*)/i);
                const isCorporate = window.location.href.match(/IsCorporate=1/i) !== null;
                if (memberIdMatches) dataLayer.push({
                    'membershipNumber': memberIdMatches[1],
                    'memberType': isCorporate ? 'corporate' : 'consumer'
                });
                break;
        }
    }
});
const $c1805f1e5c255f90$var$formulateWrappers = [
    ...document.querySelectorAll(".formulate-wrapper")
];
if ($c1805f1e5c255f90$var$formulateWrappers.length > 0) $c1805f1e5c255f90$var$formulateWrappers.forEach((wrapper)=>{
    // Analytics spreadsheet row no. 10
    wrapper.addEventListener("formulate form: submit: success", (e)=>{
        const form = e.target;
        const appointmentTypeSelect = form.querySelector('select[aria-label="Appointment Type"]');
        if (appointmentTypeSelect !== null) {
            const appointmentType = appointmentTypeSelect.value;
            dataLayer.push({
                event: "appointmentRequested",
                appointmentType: appointmentType
            });
        }
    });
});
const $c1805f1e5c255f90$var$socialShare = [
    ...document.querySelectorAll(".social-share a")
];
if ($c1805f1e5c255f90$var$socialShare.length > 0) $c1805f1e5c255f90$var$socialShare.forEach((link)=>{
    link.addEventListener("click", function() {
        const socialMedia = link.getAttribute("aria-label");
        const pageTitle = document.querySelector("meta[name='title']")?.getAttribute("content");
        dataLayer.push({
            event: "socialShare",
            social: socialMedia,
            pageTitle: pageTitle
        });
    });
});


/**
 * Utility class for handling age range selection.
 * @param selector The selector for the age range selector container.
 * @param options The options for the age range selector.
 * 
 * @example
 * import AgeRangeSelector from "./ageRangeSelector";
 * window.WFAgeRangeSelector = new AgeRangeSelector(".age-range-selector", {});
 * window.WFAgeRangeSelector.init();
 *
 * window.WFAgeRangeSelector.addSelectListener((age: string, minAge: string, maxAge: string) => {
 *   console.log(age, minAge, maxAge);
 * });
 */ class $625ecbfaca9dd29e$export$2e2bcd8739ae039 {
    constructor(selector, options){
        this.selectCallbacks = [];
        this.boundTriggers = new WeakSet();
        const defaults = {
            selectors: {
                hasChildren: '.has-children',
                hasChildrenLink: '.has-children > a',
                ageLink: '[data-age]'
            },
            closeOnOutsideClick: true,
            availableAgeRanges: []
        };
        if (typeof selector === 'string') this.container = document.querySelector(selector);
        else if (typeof selector === 'object') this.container = selector;
        this.options = Object.assign({}, defaults, options);
    }
    init() {
        this.buildPickerContent();
        this.bindTriggers();
        this.bindDocumentClick();
    }
    remove() {
        this.hidePicker();
    }
    buildPickerContent() {
        if (!this.container) return;
        const picker = document.createElement('div');
        picker.style.position = 'absolute';
        picker.style.top = '-1000px';
        picker.style.left = '-1000px';
        picker.style.zIndex = '10000';
        const ageRanges = this.options.availableAgeRanges ?? [];
        picker.appendChild(this.renderAgeRangeDropdown(ageRanges));
        this.container.appendChild(picker);
        this.picker = picker;
    }
    bindDocumentClick() {
        document.addEventListener('click', (e)=>{
            const isVisible = this.container.style.top !== '-1000px' && this.container.style.left !== '-1000px';
            if (!isVisible) return;
            const target = e.target;
            if (this.container.contains(target)) return;
            if (target.closest(this.options.selectors.trigger)) return;
            this.hidePicker();
        });
    }
    bindTriggers() {}
    onShowPicker(e) {
        e.preventDefault();
        e.stopPropagation();
        this.pickerOverflow = false;
        const trigger = e.currentTarget;
        const y = trigger.offsetTop + trigger.offsetHeight;
        let x = trigger.offsetLeft;
        const pickerRect = this.picker.getBoundingClientRect();
        var pickerRightPosition = x + pickerRect.width;
        if (pickerRightPosition > window.innerWidth) {
            x = window.innerWidth - pickerRect.width;
            this.pickerOverflow = true;
        }
        this.picker.style.left = `${x}px`;
        this.picker.style.top = `${y}px`;
    }
    openChild(childSelector) {
        const child = this.container.querySelector(`.${childSelector}`);
        if (!child) return;
        child.classList.remove('hidden');
        child.classList.add('flex');
    }
    closeAllChildren() {
        const openChildren = this.container.querySelectorAll('[class*="age-range-children-"]:not(.hidden)');
        openChildren.forEach((child)=>{
            child.classList.add('hidden');
            child.classList.remove('flex');
        });
    }
    onAgeSelect(e) {
        e.preventDefault();
        e.stopPropagation();
        const link = e.currentTarget;
        const age = link.dataset.age;
        const minAge = link.dataset.minAge;
        const maxAge = link.dataset.maxAge;
        const label = link.textContent?.trim() ?? age;
        this.hidePicker();
        this.selectCallbacks.forEach((cb)=>cb(age, minAge, maxAge, label, e));
    }
    hidePicker() {
        this.picker.style.top = '-1000px';
        this.picker.style.left = '-1000px';
    }
    addSelectListener(callback) {
        this.selectCallbacks.push(callback);
    }
    getAgeRangeFromAge(age) {
        const ageLinks = this.container.querySelectorAll(this.options.selectors.ageLink);
        for (const link of ageLinks){
            const minAge = parseInt(link.dataset.minAge ?? '0');
            const maxAge = parseInt(link.dataset.maxAge ?? '0');
            if ((minAge === 0 || age >= minAge) && (maxAge === 0 || age <= maxAge)) return {
                age: link.dataset.age,
                minAge: link.dataset.minAge,
                maxAge: link.dataset.maxAge,
                label: link.textContent?.trim() ?? link.dataset.age
            };
        }
        return null;
    }
    renderAgeRangeDropdown(options) {
        var dropdown = document.createElement('div');
        dropdown.classList.add('age-range-selector-dropdown');
        dropdown.classList.add('whitespace-nowrap');
        dropdown.classList.add('rounded-md');
        dropdown.classList.add('border');
        dropdown.classList.add('border-grey');
        dropdown.classList.add('bg-white');
        dropdown.classList.add('text-base');
        const renderOption = (options)=>{
            const items = [];
            for (const option of options)if (option.children.length > 0) {
                const optionElement = document.createElement('div');
                optionElement.classList.add('relative', 'group');
                const mainOption = document.createElement('div');
                mainOption.classList.add('dropdown-option', 'p-3', 'cursor-pointer', 'hover:bg-coolGrey', 'flex', 'items-center', 'justify-between');
                const mainOptionText = document.createElement('span');
                mainOptionText.textContent = option.text;
                const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svgIcon.classList.add('text-gray-800');
                svgIcon.setAttribute('fill', 'none');
                svgIcon.setAttribute('viewBox', '0 0 24 24');
                svgIcon.setAttribute('stroke', 'currentColor');
                svgIcon.setAttribute('width', '20');
                svgIcon.setAttribute('height', '20');
                const svgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                svgPath.setAttribute('stroke-linecap', 'round');
                svgPath.setAttribute('stroke-linejoin', 'round');
                svgPath.setAttribute('stroke-width', '2');
                svgPath.setAttribute('d', 'M9 5l7 7-7 7');
                svgIcon.appendChild(svgPath);
                mainOption.appendChild(mainOptionText);
                mainOption.appendChild(svgIcon);
                const submenuPanel = document.createElement('div');
                submenuPanel.classList.add('absolute', 'left-full', 'top-0', '-ml-2', 'pl-2', 'opacity-0', 'pointer-events-none', 'transition-opacity', 'duration-100', 'group-hover:opacity-100', 'group-hover:pointer-events-auto');
                optionElement.addEventListener('mouseenter', ()=>{
                    let wouldOverflow = false;
                    const rect = submenuPanel.getBoundingClientRect();
                    var pickerRect = this.picker.getBoundingClientRect();
                    const pickerRightEdge = pickerRect.x + pickerRect.width;
                    if (pickerRightEdge + rect.width > window.innerWidth) wouldOverflow = true;
                    submenuPanel.classList.toggle('left-full', !wouldOverflow);
                    submenuPanel.classList.toggle('right-full', wouldOverflow);
                });
                const childWrapper = document.createElement('div');
                childWrapper.classList.add('rounded-md', 'border', 'border-grey', 'bg-white', 'text-base');
                const children = renderOption(option.children);
                if (children.length > 0) for (const child of children)childWrapper.appendChild(child);
                submenuPanel.appendChild(childWrapper);
                optionElement.appendChild(mainOption);
                optionElement.appendChild(submenuPanel);
                items.push(optionElement);
            } else {
                const ageToUse = option.minAge || option.maxAge;
                const optionElement = document.createElement('div');
                optionElement.classList.add('whitespace-nowrap');
                optionElement.classList.add('dropdown-option');
                optionElement.classList.add('p-3');
                optionElement.classList.add('cursor-pointer');
                optionElement.classList.add('hover:bg-coolGrey');
                optionElement.textContent = option.text;
                optionElement.dataset.age = ageToUse;
                optionElement.dataset.minAge = option.minAge;
                optionElement.dataset.maxAge = option.maxAge;
                optionElement.addEventListener('click', this.onAgeSelect.bind(this));
                items.push(optionElement);
            }
            return items;
        };
        if (options.length > 0) {
            var items = renderOption(options);
            if (items.length > 0) for (const item of items)dropdown.appendChild(item);
        }
        return dropdown;
    }
}



var $dtgFQ = parcelRequire("dtgFQ");
window.WestfundAgeRangeSelector = (0, $625ecbfaca9dd29e$export$2e2bcd8739ae039);

if (document.querySelector('[data-semantic-statement]')) (parcelRequire("lkSG9")).then(({ default: SemanticStatement })=>{
    const semanticStatementOptions = window.Westfund?.SemanticStatementOptions ?? {};
    window.WFSemanticStatement = new SemanticStatement('[data-semantic-statement]', semanticStatementOptions);
    window.WFSemanticStatement.init();
});
(0, $dtgFQ.default)('body');


if (document.body.hasAttribute("data-join")) {
    (parcelRequire("5tLFX")).then((script)=>script.render());
    (parcelRequire("iLLRq")).then((script)=>script.render());
}


if (document.querySelectorAll(".benefits-table").length > 0) {
    (parcelRequire("g7Xn1")).then((script)=>script.render());
    (parcelRequire("2QrQH")).then((script)=>script.render());
}

if (document.querySelector(".block-review-calculator") !== null) (parcelRequire("jB2uX")).then((script)=>script.render());

if (document.getElementById("new-product-table") !== null) (parcelRequire("70kBm")).then((script)=>script.render());

if (document.getElementById("map") !== null) (parcelRequire("kzXD6")).then((script)=>script.render());

if (document.getElementById("save-quote-modal") !== null || document.getElementById("callback-modal") !== null) (parcelRequire("9ttiI")).then((script)=>script.render());

if (document.querySelector("[data-tabs]") !== null) (parcelRequire("kIatT")).then((script)=>script.render());

if (document.querySelector(".modal") !== null) (parcelRequire("5Ym2Q")).then((script)=>script.render());

if (document.querySelector(".in-page-links") != null) (parcelRequire("7vcEJ")).then((script)=>script.render());

if (document.querySelector(".loading-button, .onunload-loading-button") != null) (parcelRequire("1yqaf")).then((script)=>script.render());

if (document.getElementById("chatTemplate") !== null) {
    const localOrIpAddress = new RegExp(/localhost|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}|::1|\.local|^$/gi);
    const isLocalOrIpAddress = localOrIpAddress.test(window.location.hostname);
    if (window.location.hostname !== "" && !isLocalOrIpAddress) (parcelRequire("bir69")).then((script)=>{
        script.render();
    // script.open();
    });
}
if (document.getElementById("globalDisplayBanner") !== null) {
    var $27605a8ae547331f$var$globalDisplayBanner = document.getElementById("globalDisplayBanner");
    document.getElementById("globalDisplayBannerAction").addEventListener("click", function() {
        $27605a8ae547331f$var$globalDisplayBanner.style.display = "none";
        sessionStorage.setItem("closedGlobalDisplayBanner", "true");
    });
    if (!sessionStorage.getItem("closedGlobalDisplayBanner")) $27605a8ae547331f$var$globalDisplayBanner.style.display = "block";
}

})();
//# sourceMappingURL=main.js.map
